import { Alert } from '@/design-system';
import type { Problem } from '@/lib/problem';

/** A refusal, with the request id a person can quote when reporting it. */
export function ProblemAlert({ problem, title }: { problem: Problem; title: string }) {
  return (
    <Alert tone="danger" title={title}>
      {problem.message}
      {problem.requestId && (
        <>
          {' '}
          Request id: <span className="numeric">{problem.requestId}</span>.
        </>
      )}
    </Alert>
  );
}
